import { DvSnackbarConfig } from '@devinco/ui/dds/snackbar';

export const SnackBarConfig: {
  Success: DvSnackbarConfig;
  Warning: DvSnackbarConfig;
  Error: DvSnackbarConfig;
  Default: DvSnackbarConfig;
} = {
  Success: {
    displayTime: 4000,
    vPos: 'top',
    type: 'success',
  },
  Error: {
    displayTime: 4000,
    vPos: 'top',
    type: 'danger',
  },
  Warning: {
    displayTime: 2000,
    vPos: 'top',
    type: 'warning',
  },
  Default: {
    displayTime: 2000,
    vPos: 'top',
    type: 'default',
  },
};
